import { render } from "./SendDocumentDialog.vue?vue&type=template&id=483bdab2&scoped=true"
import script from "./SendDocumentDialog.vue?vue&type=script&lang=js"
export * from "./SendDocumentDialog.vue?vue&type=script&lang=js"

import "./SendDocumentDialog.vue?vue&type=style&index=0&id=483bdab2&lang=css"
import "./SendDocumentDialog.vue?vue&type=style&index=1&id=483bdab2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483bdab2"]])

export default __exports__